import { throwError as observableThrowError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SecurityService, UserInfo } from './security.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Configuration } from '../../app.configuration.service';
import { FileInfo } from '../model/generic/fileInfo';
import { decode } from 'base64-arraybuffer';
import { ApplicationError } from '../model/generic/applicationError';

@Injectable()
export class HttpHelperDataService {

  public controllerName: string;
  public headers: HttpHeaders;
  public options: any;

  private oAuthToken: string;

  constructor(protected http: HttpClient, protected configuration: Configuration, protected securityService: SecurityService) {
    var timeZone = new Date().getTimezoneOffset();

    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json');
    this.options = { headers: this.headers };

    securityService.UserInfoSubscribe((data: UserInfo) => {
      if (this.headers.has('Authorization')) { this.headers.delete('Authorization'); }
      this.oAuthToken = '';
      if (data) {
        this.oAuthToken = data.accessToken;
        this.headers = new HttpHeaders()
          .set('Access-Control-Allow-Origin', '*')
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json')
          .set('Authorization', 'Bearer ' + this.oAuthToken)
          .set('TimeZone', timeZone.toString());
        this.options = { headers: this.headers };
      }
    });
  }

  /**
   * Execute GET request on Server API to Json Types
   */
  public httpGet: any = (actionName: string, params?: any): Observable<any> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/${actionName}`;
    return this.http
      .get(fullUrl, this.options)
      .pipe(
        map(response => response)
        , catchError(this.handleError)
      );
  }

  /**
   * Execute GET request on Server API to GetFiles
   */
  public httpGetFile: any = (actionName: string, params?: any): Observable<FileInfo> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/${actionName}`;
    return this.http
      .get(fullUrl, this.options)
      .pipe(
        map(response => {
          const myData = response;
          const myFileInfo = new FileInfo();
          myFileInfo.filename = (myData as any).filename;
          myFileInfo.content = new Blob([decode((myData as any).content)], { type: (myData as any).contentType });
          return myFileInfo;
        })
        , catchError(this.handleError));
  }

  /**
   * Execute GET request on Server API to Get multiples Files
   */
  public httpGetFiles: any = (actionName: string, params?: any): Observable<FileInfo[]> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/${actionName}`;
    return this.http
      .get(fullUrl, this.options)
      .pipe(
        map(response => {
          const myData = response;
          const myFiles = new Array<FileInfo>();
          (myData as any).forEach((file: any) => {
            if ((file as any).content != null) {
              const myFileInfo = new FileInfo();
              myFileInfo.filename = (file as any).filename;
              myFileInfo.content = new Blob([decode((file as any).content)], { type: (file as any).contentType });
              myFiles.push(myFileInfo);
            }
          });
          return myFiles;
        })
        , catchError(this.handleError));
  }

  public httpGetFileNative: any = (actionName: string, params?: any): Observable<any> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/${actionName}`;

    const myHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + this.oAuthToken)
      .set('responseType', 'blob');

    const myOptions = { headers: myHeaders };

    return this.http
      .get(fullUrl, myOptions)
      .pipe(
        map(response => {
          const myData = response;
        })
        , catchError(this.handleError));
  }

  /**
   * Execute POST request on Server API and returns a file
   */
  public httpPostGetFile: any = (actionName: string, data: any): Observable<FileInfo> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/${actionName}`;
    return this.http
      .post(fullUrl, data, this.options)
      .pipe(
        map(response => {
          const myData = response;
          const myFileInfo = new FileInfo();
          myFileInfo.filename = (myData as any).filename;
          myFileInfo.content = new Blob([decode((myData as any).content)], { type: (myData as any).contentType });
          return myFileInfo;
        })
        , catchError(this.handleError));
  }

  /**
   * Execute POST request on Server API
   */
  public httpPost: any = (actionName: string, data: any): Observable<any> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/${actionName}`;
    return this.http
      .post(fullUrl, data, this.options)
      .pipe(
        map(response => response)
        , catchError(this.handleError));
  }

  /**
   * Execute PUT request on Server API
   */
  // public httpPut: any = <T>(actionName: string, data: any): Observable<T> => {
  //   const fullUrl = `${this.configuration.server}/api/${this.controllerName}/${actionName}`;
  //   return this.http
  //     .put(fullUrl, data, this.options)
  //     .map(response => response)
  //     .catch(this.handleError);
  // }

  /**
   * Execute DELETE request on Server API
   */
  // public httpDelete: any = <T>(actionName: string, params?: any): Observable<T> => {
  //   const fullUrl = `${this.configuration.server}/api/${this.controllerName}/${actionName}`;
  //   return this.http
  //     .delete(fullUrl, this.options)
  //     .map(response => response)
  //     .catch(this.handleError);
  // }

  public handleError(err: any) {
    let errMsg: string;

    if (err instanceof ApplicationError) {
      return observableThrowError(err);
    }

    try {
      const errorObject = JSON.parse(err._body);
      if (errorObject) {
        if (errorObject.error) {
          errMsg = errorObject.error + ' - ' + errorObject.error_description;
        } else if (errorObject.exceptionMessage) {
          errMsg = errorObject.exceptionMessage;
        }
      }
      return observableThrowError(errMsg);
    } catch (error) {
    }

    if (err.error instanceof Error) {
      errMsg = 'An error occurred:' + err.error.message;
    } else {
      errMsg = `Backend returned code ${err.status}, body was: ${err.error}`;
    }

    console.error(errMsg);
    return observableThrowError(errMsg);
  }
}
